import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';
export class Patti extends Lit3formBlock {
  static get characterName() {
    return 'patti';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid patti-layout">
          <div class="description">
            <h2>${unsafeHTML(this.headerText)}</h2>
            <p class="description-text">${unsafeHTML(this.introductionText)}</p>
            <cta-text
              cta-data=${this.ctaData}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaData,
                this.headerText
              )}
            ></cta-text>
          </div>
          <div class="image">
            <img src=${this.imagebossUrl(this.imageUrl, '450', null)} />

            <image-caption
              description=${this.imageDescription}
              file-url=${this.fullResolutionImgUrl || ''}
              placement=${this.headerText}
            ></image-caption>
          </div>
          ${this.descriptionTextHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get descriptionTextHTML() {
    return !!this.descriptionText
      ? html`
          <div class="text">
            <h3>${unsafeHTML(this.descriptionText)}</h3>
          </div>
        `
      : html``;
  }

  get headerText() {
    return this.content.header || '';
  }

  get introductionText() {
    return this.content.introduction || '';
  }

  get descriptionText() {
    return this.content.description || '';
  }

  get imageUrl() {
    return this.content.image.src || '';
  }

  get fullResolutionImgUrl() {
    return this.content.image.full_resolution_src || '';
  }

  get imageDescription() {
    const regex = /\s*\r\n|\r|\n\s*/gi;
    return this.content.image.description.replaceAll(regex, '<br>');
  }

  get ctaData() {
    return JSON.stringify(this.content.cta);
  }
}
Patti.defineElement();
